import { TicketUtils } from "@app/layout/sites/tickets/ticket-utils";
import { AbstractMatch, AnchorTagBuilder, MatchType } from "autolinker";
import { emailRegex } from "./email-match";
import { parseCustomMatches } from "./match.util";

const mentionRegex = new RegExp(TicketUtils.MENTION_CHARACTER + emailRegex.source, emailRegex.flags);

export class MentionMatch extends AbstractMatch {
  public static readonly matchName = 'custom-mention';
  type: MatchType = <any>MentionMatch.matchName;
  getType(): MatchType | typeof MentionMatch.matchName | any {
    return MentionMatch.matchName;
  }
  getAnchorHref(): string {
    return 'mailto:' + this.matchedText.slice(TicketUtils.MENTION_CHARACTER.length);
  }
  getAnchorText(): string {
    return this.matchedText;
  } 
}

export function parseMentionMatches(src: string, tagBuilder: AnchorTagBuilder, existingMatches: AbstractMatch[]): MentionMatch[] {
  return parseCustomMatches(mentionRegex, src, existingMatches, (match, index) => new MentionMatch({
    tagBuilder: tagBuilder,
    matchedText: match,
    offset: index
  }));
}